import analytics from 'shared-assets/lib/analytics';

angular.module('kareo.tracking-configuration', [
  'kareo.ui.shared.modules.data',
])
  .run([
    'practice', 'authenticatedUser', async function (practice, authenticatedUser) {
      const [practiceData, user] = await Promise.all([practice.get(), authenticatedUser.get()]);

      if (!practiceData.customerId || !practiceData.practiceGuid || !user.userGuid) {
        // If we haven't authenticated the user (ie. don't know who they are) should we set a temporary id or something here?
        return;
      }

      const identity = `${practiceData.customerId}_${practiceData.practiceGuid}_${user.userGuid}`;
      analytics.identify(identity);
    }]);
